module.exports = __webpack_public_path__ + "assets/media/message.a389f6c0.mp3";